module.exports = __webpack_public_path__ + "static/media/SameerSawant_Fullstack.54811a29.docx";


//////////////////
// WEBPACK FOOTER
// ./src/assets/SameerSawant_Fullstack.docx
// module id = 153
// module chunks = 0